import { useDesignContext } from '../../../../../providers/DesignContextProvider';
import IntlDropdown from './IntlDropdown';

function NavbarUser() {
  const { UserDropDown, AlertDropdown } = useDesignContext();
  
  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <IntlDropdown />
      {AlertDropdown && <AlertDropdown />}
      {UserDropDown && <UserDropDown />}
    </ul>
  );
}
export default NavbarUser;
